import React from "react";

import "./footer.scss";
import poweredBy from "../../assets/imgs/poweredBy-footer.svg";
import logoFooter from "../../assets/imgs/logo-footer.svg";

const Footer = () => {
    return (
        <footer className="container footer">
            <div className="grid wide">
                <div className="footer__content">
                    <div className="join-telegram">
                        <h4>Don’t miss our weekly updates about DOSE Token</h4>
                        <div className="btn btn__fill-orange">
                            <a
                                href="https://t.me/dose_community"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Join us on Telegram
                            </a>
                        </div>
                    </div>

                    <div className="connect__link">
                        <div className="footer__imgLogo">
                            <img src={logoFooter} alt="dose logo" />
                            <p className="powerBy">
                                Powered by <img src={poweredBy} alt="" />
                            </p>
                        </div>

                        <div className="footer__social">
                            <a
                                href="https://t.me/dose_news"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="ri-twitter-fill"></i>
                            </a>
                            <a
                                href="https://www.dosetoken.com/images/logos/youtube.svg"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="ri-youtube-fill"></i>
                            </a>
                            <a
                                href="https://www.facebook.com/tokendose"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="ri-facebook-circle-fill"></i>
                            </a>
                            <a
                                href="https://twitter.com/DOSEToken"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="ri-send-plane-fill"></i>
                            </a>
                        </div>
                    </div>

                    <div className="dose-connect"></div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
